import { cva } from '@vizit/theme';
import { HeadingVariant } from './types';

export const headingClasses = cva({
  base: 'text-primary font-serif font-light',
  variants: {
    variant: {
      [HeadingVariant.H1]: 'text-display-2xl tracking-display-2xl',
      [HeadingVariant.H2]: 'text-display-xl tracking-display-xl',
      [HeadingVariant.H3]: 'text-display-lg tracking-display-lg',
      [HeadingVariant.H4]: 'text-display-md tracking-display-md',
      [HeadingVariant.H5]: 'text-display-sm',
      [HeadingVariant.H6]: 'text-display-xs',
      [HeadingVariant.Eyebrow]: 'text-sm text-tertiary font-sans',
    },
  },
  defaultVariants: {
    variant: HeadingVariant.H1,
  },
});
